<template>
	<CreationWizardStepWrapper>
		<template #header>
			<NeedPlyExtensionToUseAddOnHeader v-bind="$props" v-on="$listeners" />
		</template>
		<InstallPlyExtensionLoader class="width-100 height-100" @extension-installed="nextStep" />
	</CreationWizardStepWrapper>
</template>

<script>
import WizardStepMixin from '../WizardStepMixin';
import NeedPlyExtensionToUseAddOnHeader from './NeedPlyExtensionToUseAddOnHeader.vue';
import props from './NeedPlyExtensionToUseAddOn.props';
import InstallPlyExtensionLoader from '@/components/InstallPlyExtensionLoader.vue';
export default {
	name: 'NeedPlyExtensionToUseAddOn',
	mixins: [WizardStepMixin],
	props,
	components: { NeedPlyExtensionToUseAddOnHeader, InstallPlyExtensionLoader },
};
</script>

<style lang="scss" scoped></style>
